export interface PartnerClientLinkDTOe {
  active                       : boolean;
  agreedAccuracyLevel?         : number;
  approvedByName?              : string;
  approvedByUserIdEncSS?       : string;
  approvedUtc?                 : string;
  clientCompanyIdEncSS         : string;
  clientCompanyName            : string;
  endUtc?                      : string;
  idEncSS                      : string;
  includeDescendants           : boolean;
  partnerClientRef?            : string;
  partnerCompanyIdEncSS        : string;
  partnerCompanyName           : string;
  partnerHasActiveWebhookConfig: boolean;
  startUtc?                    : string;
}

export function PartnerClientLinkDTOe_EmptyObject(): PartnerClientLinkDTOe {
  return {
    active                       : false,
    clientCompanyIdEncSS         : "",
    clientCompanyName            : "",
    idEncSS                      : "",
    includeDescendants           : false,
    partnerCompanyIdEncSS        : "",
    partnerCompanyName           : "",
    partnerHasActiveWebhookConfig: false
  };
}

export interface PartnerClientLinkAddDTOe {
  agreedAccuracyLevel? : number;
  approvedUtc?         : string;
  clientCompanyIdEncSS : string;
  includeDescendants   : boolean;
  partnerClientRef?    : string;
  partnerCompanyIdEncSS: string;
  startUtc?            : string;
}

export function PartnerClientLinkAddDTOe_EmptyObject(): PartnerClientLinkAddDTOe {
  return {
    clientCompanyIdEncSS : "",
    includeDescendants   : false,
    partnerCompanyIdEncSS: ""
  };
}
